import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { MisVisitasFilters } from './MisVisitasFilters';
import { useGetColumns } from '../hooks/useGetColumns';
import { useGetFilters } from '../hooks/useGetFilters';
import { useGetRows } from '../hooks/useGetRows';
import { useMemo, useState } from 'react';
import './misVisitasContent.scss';

export const MisVisitasContent = () => {
    const [expandedId, setExpandedId] = useState(null);

    // Pagination state (frontend only)
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(0); // 0-based

    const {
        filters,
        handleChangeFilters,
        delegaciones,
        pacientes
    } = useGetFilters();

    const {
        rows,
        setRows,
        loading,
        totalCount
    } = useGetRows(filters);

    const columns = useGetColumns(filters, expandedId, setExpandedId, rows);

    const handleFilters = (name, value) => {
        setRows([]);
        setExpandedId(null);
        handleChangeFilters(name, value);
    }

    // Pagination handlers (frontend only)
    const onPageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const onPageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
        setCurrentPage(0); // Reset to first page when page size changes
    };

    const getRowHeight = (params) => params?.model?.__isDetail ? 'auto' : null;

    // Función para aplicar clases CSS según las props de la row
    const getRowClassName = (params) => {
        const classes = [];

        // Mantener el patrón de rayas (even/odd), estilo default de componente DataGrid
        if (params.indexRelativeToCurrentPage % 2 === 0) {
            classes.push('even');
        } else {
            classes.push('odd');
        }

        if (params.row.__isDetail) {
            classes.push('detail-row');
        }

        // Ejemplo: agregar clase según el estado
        if (!!params?.row?.periodoSuspension) {
            classes.push('row-suspension');
        }

        return classes.join(' ');
    };

    const paginatedRows = useMemo(() => {
        const start = currentPage * pageSize;
        const end = start + pageSize;
        const pageRows = rows.slice(start, end);

        return pageRows.flatMap(row => {
            if (expandedId === row.idEvaluacionProfesional) {
                return [
                    row,
                    {
                        idEvaluacionProfesional: `${row.idEvaluacionProfesional}-detail`,
                        __isDetail: true,
                        __parentId: row.idEvaluacionProfesional,
                    }
                ];
            }
            return [row];
        });
    }, [rows, currentPage, pageSize, expandedId]);

    return (
        <div>
            <MisVisitasFilters
                delegaciones={delegaciones}
                pacientes={pacientes}
                filters={filters}
                handleChangeFilters={handleFilters}
            />
            <DataGridGenerico
                columns={columns}
                rows={paginatedRows}
                totalCount={totalCount}
                loading={loading}
                toolbar={false}
                autoMaxWidth
                getRowHeight={getRowHeight}
                getRowClassName={getRowClassName}
                pageSize={pageSize}
                currentPage={currentPage}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
            />
        </div>
    );
}